<template>
  <div 
    @click.stop="displayEvent(numYear, 'event'+numYear)"
    v-click-outside="closeEvent"
    class="w-max shadow-lg rounded-xl transition ease-in-out duration-300 cursor-pointer"
    :id="'event'+numYear"
  >
    <div class="flex items-center p-2 cursor-pointer">
      <div class="flex items-center">
        <div :class="colors.color+' '+colors.bg+' p-4 w-3 h-3 rounded-full flex items-center justify-center'">
          <div class="text-base">
            {{ year.event.length }}
          </div>
        </div>
        <div class="text-base ml-2.5"> 
          Évènements
        </div>
      </div>

      <div class="flex-grow" />

      <div 
        v-if="!isDisplayedEvent"
        :class="colors.color+' ml-2.5'"
      >
        <icon name="chevron-down" />
      </div>
      <div
        v-if="isDisplayedEvent" 
        :class="colors.color+' ml-2.5'"
      >
        <icon name="chevron-right" />
      </div>
    </div>
    <transition
      enter-active-class="transition ease-out duration-100"
      enter-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <div 
        v-if="isDisplayedEvent"
        class="px-4 pb-3 text-sm text-gray-600 w-max"
      >
        <div 
          v-for="event in year.event"
          :key="event"
          class="flex space-x-1 items-center"
        >
          <icon 
            :name="decorationByEvent[event.type][event.event.type].icon" 
            :class="decorationByEvent[event.type][event.event.type].color+' text-base w-3 mr-1'" 
          />
          <div class="text-gray-900">
            {{ event.event.type }}
          </div>
          <div
            class="text-gray-600"
            v-if="(event.event.debut || event.event.fin) && event.event.type"
          >
            :
          </div>
          <div class="text-gray-600">
            <span v-if="event.event.debut">{{ ('0' + new Date(event.event.debut).getDate()).slice(-2) }}/{{ ('0' + (new Date(event.event.debut).getMonth()+1)).slice(-2) }}/{{ new Date(event.event.debut).getFullYear() }}</span>
            <span v-if="event.event.debut && event.event.fin"> - </span> 
            <span v-if="event.event.fin">{{ ('0' + new Date(event.event.fin).getDate()).slice(-2) }}/{{ ('0' + (new Date(event.event.fin).getMonth()+1)).slice(-2) }}/{{ new Date(event.event.fin).getFullYear() }}</span>
          </div>
          <div
            class="text-gray-600"
            v-if="event.event.intitule"
          >
            /
          </div>
          <div class="text-gray-600 italic">
            {{ event.event.intitule }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Icon from './../Icon';
import ClickOutside from 'vue-click-outside';
import Constants from './../../constants';

export default {
  components:{
    Icon,
  },

  props:{
    year: Object,
    numYear: Number,
    isDisplayedEvent:Boolean,
  },

  data(){
    return {
      decorationByEvent:Constants.FRISE_CHRONOLOGIQUE_DECORATION_BY_EVENT,
    };
  },

  methods:{
    displayEvent(){
      if(!this.isDisplayedEvent){
        this.$emit('displayEvent');
      }else{
        this.closeEvent();
      }
    },
    closeEvent(){
      if(this.isDisplayedEvent){
        this.$emit('closeEvent');
      }
    }
  },
  computed:{
    colors(){
      let colors = {
        bg: 'bg-gray-300',
        color: 'text-gray-600'
      };

      if(this.year.event.length > 0){
        let firstEvent = this.year.event[0];
        colors.bg = this.decorationByEvent[firstEvent.type][firstEvent.event.type].bg;
        colors.color = this.decorationByEvent[firstEvent.type][firstEvent.event.type].color;
      }

      return colors;
    }
  },
  directives:{
    ClickOutside
  }
};
</script>